
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4250"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4250"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("gApu6", function(module, exports) {

$parcel$export(module.exports, "api", () => $2729d7a6498e4ddb$export$644d8ea042df96a6);
const $2729d7a6498e4ddb$var$STORAGE_KEY = "PUBLIC_SURVEY_IDENTITY";
function $2729d7a6498e4ddb$var$generateCooperativeBrowserIdentity() {
    return new Date().toISOString().split("T")[0] + "_" + Math.floor(Math.random() * 1000000);
}
function $2729d7a6498e4ddb$export$acc9bcaae878c209() {
    let id = localStorage.getItem($2729d7a6498e4ddb$var$STORAGE_KEY);
    if (!id) {
        id = $2729d7a6498e4ddb$var$generateCooperativeBrowserIdentity();
        localStorage.setItem($2729d7a6498e4ddb$var$STORAGE_KEY, id);
    }
    return {
        cooperative_browser: id
    };
}
function $2729d7a6498e4ddb$export$1617268687ac763c() {
    const url = new URL(document.URL);
    const params = url.searchParams;
    if (params.has("identity")) return JSON.parse(params.get("identity"));
    else if (params.has("anonymous")) return null // {userId : "anonymous"}
    ;
    else if (params.has("browserid")) return $2729d7a6498e4ddb$export$acc9bcaae878c209();
    else if (params.has("user")) return {
        credentials: {
            user: params.get("user"),
            password: params.get("password")
        }
    };
    else return $2729d7a6498e4ddb$export$acc9bcaae878c209();
}
function $2729d7a6498e4ddb$export$68b378e7c2dd98d3() {
    const url = new URL(document.URL);
    if (url.searchParams.has("api_endpoint")) {
        const endpoint = url.searchParams.get("api_endpoint");
        return new URL(endpoint).toString();
    }
    if (url.hostname.includes("localhost")) return `http://localhost:4000/`;
    else return `${url.origin}/api/`;
}
async function $2729d7a6498e4ddb$export$644d8ea042df96a6(route, body) {
    while(route.startsWith("/"))route = route.slice(1);
    const url = $2729d7a6498e4ddb$export$68b378e7c2dd98d3() + route;
    let options = {};
    const userId = $2729d7a6498e4ddb$export$1617268687ac763c();
    if (userId) body = {
        ...body || {},
        userId: userId
    };
    if (body) options = {
        ...options,
        method: "POST",
        body: JSON.stringify(body),
        headers: {
            "content-type": "application/json"
        }
    };
    const response = await fetch(url, options);
    if (!response.ok) {
        const message = await response.text();
        throw `api returned ${response.statusText} : ${message}`;
    }
    let result = null;
    try {
        result = await response.json();
    } catch (err) {
        throw `result is not a json`;
    }
    return result;
}

});

parcelRegister("cP3LP", function(module, exports) {

$parcel$export(module.exports, "getClassData", () => $955d2c31eafd4c00$export$3f5d7aac17789983);
$parcel$export(module.exports, "getJsonFromElement", () => $955d2c31eafd4c00$export$6be7b37ff53da754);
function $955d2c31eafd4c00$export$3f5d7aac17789983(element) {
    while(element !== null){
        // Vérifie si l'élément courant a la classe 'data'
        if (element.classList.contains("data")) return element;
        element = element.parentElement;
    }
    return null;
}
function $955d2c31eafd4c00$export$6be7b37ff53da754(element) {
    const json = {};
    // Trouver tous les descendants qui ont la classe 'entry'
    const entries = element.querySelectorAll(".entry");
    entries.forEach((entry)=>{
        const title = entry.getAttribute("title");
        let value;
        if (entry.tagName.toLowerCase() === "input") {
            if (entry.type === "text") json[title] = entry.value.trim();
            else if (entry.type === "checkbox") json[title] = entry.checked;
            else json[title] = entry.value.trim();
        } else if (entry.tagName.toLowerCase() === "ul") {
            const listResult = [];
            const listItems = entry.querySelectorAll(".item");
            listItems.forEach((listItem)=>{
                const listItemTitle = listItem.getAttribute("title");
                if (listItem.tagName.toLowerCase() === "input") {
                    if (listItem.type === "text") listResult.push(listItem.value.trim());
                    else if (listItem.type === "checkbox") {
                        if (listItem.checked) listResult.push(listItem.title);
                    } else listResult.push(listItem.value.trim());
                }
            });
            json[title] = listResult;
        } else json[title] = entry.textContent.trim();
    });
    return json;
}

});


var $gApu6 = parcelRequire("gApu6");

var $cP3LP = parcelRequire("cP3LP");
console.log((0, $cP3LP.getJsonFromElement));
document.addEventListener("DOMContentLoaded", ()=>{
    const responsesList = document.getElementById("responsesList");
    const createButton = document.getElementById("createButton");
    const addResponse = async ()=>{
        const div = document.createElement("div");
        div.classList.add("input-group");
        const span = document.createElement("span");
        const input = document.createElement("input");
        const button = document.createElement("button");
        span.textContent = `Answer`;
        span.classList.add("input-group-text");
        span.id = "basic-addon3";
        span.style = "background-color: #c6ddfa";
        div.appendChild(span);
        input.classList.add("form-control");
        input.classList.add("item");
        input.title = "title";
        input.type = "text";
        div.appendChild(input);
        button.type = "button";
        button.classList.add("btn");
        button.classList.add("btn-outline-success");
        button.style = "background-color: #c6ddfa";
        button.textContent = ` + `;
        div.appendChild(button);
        responsesList.appendChild(div);
        button.addEventListener("click", (evt)=>{
            addResponse();
        });
    };
    const createSurvey = async ()=>{
        const paramsList = document.getElementById("paramsList");
        const outjson = (0, $cP3LP.getJsonFromElement)(paramsList);
        console.log(outjson);
        try {
            const response = await (0, $gApu6.api)("/surveys/create", outjson);
            console.log(response);
        } catch (err) {
            console.error(err);
            document.querySelector("#debug").innerHTML = err.toString();
        }
    };
    createButton.addEventListener("click", (evt)=>{
        createSurvey();
    });
    addResponse();
});


//# sourceMappingURL=creation-page.8af429d0.js.map
